import React from "react";
import {ListItem, Paragraph, SectionHeading} from "../PrivacyPolicyText";

const InformationCollectionSection = () => (
  <>
    <SectionHeading>{"Information We Collect About You and How We Collect It"}</SectionHeading>

    <Paragraph>
      {"We collect several types of information from and about users of our Services, including information:"}
    </Paragraph>

    <ListItem>
      {"By which you may be personally identified, such as first and last name, postal address, e-mail address, telephone number, IP address, browser type, account information, such as usernames and passwords, usage data, device identifying information, or any other identifier by which you may be contacted online or offline (\"personal information\");"}
    </ListItem>

    <ListItem>
      {"Face scans for know your customer (“KYC”) purposes and then to match when you log in and to confirm you are playing (“biometric information”);"}
    </ListItem>

    <ListItem>
      {"You may decide to share your first and last name, date of birth, location, email address, phone number, username and password, and the state in which you reside when you create an account to log in to our network (\"Account\"). We need this information to set up your Account, verify your identity, and provide you with our Services or Challenges;"}
    </ListItem>

    <ListItem>
      {"When you use our Website, Applications or Services or Challenges, or deposit or withdraw funds from your Account, We may collect all information necessary to complete the transaction and provide you with the Services, including your name, address, email address, phone number, credit or debit card information and other billing information, social security number, tax documents, and records of the products and Services or Challenges you purchased, obtained, or considered;"}
    </ListItem>

    <ListItem>
      {"If you provide Us feedback or contact Us via email, We will collect your name and email address, as well as any other content provided in the email, in order to send you a reply, provide customer and technical support, improve and optimize our Services, satisfy our legal obligations, enforce our contracts, and address any existing or anticipated disputes;"}
    </ListItem>

    <ListItem>
      {"We will collect certain biometric information which you may upload, including, but not limited to a profile photo, with data derived from the photo you upload and username you choose for your public profile page including in connection with our Services. When you utilize our Services or Challenges, other users may be able to see the information you selected for your Profile;"}
    </ListItem>

    <ListItem>
      {"If you tell Us where you are (e.g., by allowing your mobile device to send Us your location or by otherwise permitting Us to geolocate you), We may store and use that information to verify your eligibility to use our Services, to comply with relevant laws, and for fraud prevention purposes;"}
    </ListItem>

    <ListItem>{"That is about you but individually does not identify you;"}</ListItem>

    <ListItem>
      {"About your internet connection, the equipment you use to access our Services, and usage details; and/or"}
    </ListItem>

    <ListItem withBottomMargin>
      {"Biometric information (see Biometric Privacy Policy for additional information), if you have affirmatively consented to our collection of such information."}
    </ListItem>

    <Paragraph>{"We collect this information:"}</Paragraph>

    <ListItem>{"Directly from you when you provide it to us; and"}</ListItem>

    <ListItem withBottomMargin>
      {"Automatically as you navigate through the Website, Applications, or other platform associated with our Services and/or Challenges. Information collected automatically may include usage details, IP addresses, and information collected through cookies and web beacons."}
    </ListItem>
  </>
);

export default InformationCollectionSection;
